/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EngagementFollowerDto } from '../../models/engagement-follower-dto';

export interface GetEngagementFollowers$Params {
}

export function getEngagementFollowers(http: HttpClient, rootUrl: string, params?: GetEngagementFollowers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EngagementFollowerDto>>> {
  const rb = new RequestBuilder(rootUrl, getEngagementFollowers.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EngagementFollowerDto>>;
    })
  );
}

getEngagementFollowers.PATH = '/api/company/engagement/followers';
